document.addEventListener('DOMContentLoaded', () => {
  const accordionTitles = document.querySelectorAll('.acc__title');

  accordionTitles.forEach(title => {
    title.addEventListener('click', () => {
      // Toggle active class on clicked title
      title.classList.toggle('active');

      // Get the associated panel
      const panel = title.nextElementSibling;

      // Toggle panel visibility
      if (panel.style.display === 'block') {
        panel.style.display = 'none';
      } else {
        panel.style.display = 'block';
      }

      // Optional: Close other open panels
      accordionTitles.forEach(otherTitle => {
        if (otherTitle !== title && otherTitle.classList.contains('active')) {
          otherTitle.classList.remove('active');
          otherTitle.nextElementSibling.style.display = 'none';
        }
      });
    });
  });
});